<div class="content-container">
    <nav class="navbar sticky-top">
        <div class="d-grid gap-2 d-flex navbar-brand">
            <button (click)="location.back()" type="button" ngbTooltip="Back" placement="bottom"
                class="btn btn-primary backBtn" aria-label="Back">
                <fa-icon [icon]="faAngleLeft"></fa-icon>
            </button>

            <h2 class="mobileHeading">Monthly Payments</h2>
        </div>

        <div class="row w-100 justify-content-end">
            <div class="col-auto pe-2">
                <app-date-picker-controller #datePickerController componentId="Reports.MonthlyPayments" preset="CUR_MTH"
                    [showButtons]="true" (dateChanged)="dateChanged($event)"
                    [onLoad]="false"></app-date-picker-controller>
            </div>

            <div class="col-auto" style="padding-top: .15rem">
                <button type="button" class="btn btn-primary" (click)="downloadReport()">
                    <fa-icon [icon]="faFileDownload"></fa-icon>
                    <span class="ms-2 d-none d-md-inline">Export</span>
                </button>
            </div>

            <div class="col-auto sort" *ngIf="isMobile" style="padding-top: .15rem">
                <ng-container *ngTemplateOutlet="SORT_DROPDOWN"></ng-container>
            </div>
        </div>
    </nav>

    <div class="row mt-3">
        <div class="card p-0">
            <div class="card-body">
                <h5 class="card-title">Description</h5>
                <p class="card-text m-0">
                    This report shows monthly payment details including invoice amount,
                    sales tax, amount paid, proposal subtotal, balance due, and payment type.
                </p>
            </div>
        </div>
    </div>

    <div class="row mt-3 align-items-end justify-content-end g-2">
        <div class="col-12 col-md-3">
            <div class="input-group">
                <input type="search" class="form-control" placeholder="Search client, county, payment type..."
                    [(ngModel)]="searchTerm" (keyup.enter)="search()" (search)="search()" />

                <button type="button" class="btn btn-primary" (click)="search()">
                    <fa-icon [icon]="faSearch"></fa-icon>
                    <span class="ms-1">Search</span>
                </button>
            </div>
        </div>

        <div class="col-12 col-md-auto" *ngIf="searchTerm">
            <button type="button" class="btn btn-outline-danger w-100" (click)="clearSearch()">
                Clear
            </button>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col table-responsive">
            <table *ngIf="!isMobile" class="table table-hover monthly-payments-table">
                <thead>
                    <tr>
                        <th (click)="sorting('clientName')">
                            Client Name
                            <fa-icon *ngIf="sortBy === 'clientName'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>
                        <th (click)="sorting('invoiceNumber')">
                            Invoice Number
                            <fa-icon *ngIf="sortBy === 'invoiceNumber'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('proposalSubtotal')">
                            Proposal Subtotal:<br />
                            BEFORE TAX &<br />
                            AFTER DISCOUNT
                            <fa-icon *ngIf="sortBy === 'proposalSubtotal'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('taxRate')">
                            Tax rate
                            <fa-icon *ngIf="sortBy === 'taxRate'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('proposalTaxName')">
                            Tax Name
                            <fa-icon *ngIf="sortBy === 'proposalTaxName'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('proposalSalesTax')">
                            PROPOSAL Sales Tax
                            <fa-icon *ngIf="sortBy === 'proposalSalesTax'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('totalSale')">
                            Accepted Proposal
                            <fa-icon *ngIf="sortBy === 'totalSale'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('invoicedSalesTax')">
                            INVOICED Sales Tax
                            <fa-icon *ngIf="sortBy === 'invoicedSalesTax'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('invoiceAmount')">
                            Invoice Amount
                            <fa-icon *ngIf="sortBy === 'invoiceAmount'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('amountPaid')">
                            Amount Paid
                            <fa-icon *ngIf="sortBy === 'amountPaid'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('paymentType')">
                            Payment Type
                            <fa-icon *ngIf="sortBy === 'paymentType'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('paymentDate')">
                            Payment Date
                            <fa-icon *ngIf="sortBy === 'paymentDate'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>

                        <th (click)="sorting('balanceDueOnProject')">
                            Balance Due On Project<br />
                            (After this payment)
                            <fa-icon *ngIf="sortBy === 'balanceDueOnProject'"
                                [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp" class="sortButton"></fa-icon>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let entry of entries">
                        <td data-label="Client Name">{{ entry.clientName }}</td>
                        <td data-label="Invoice Number">
                            <a [routerLink]="`/invoices/${entry.invoiceId}`">{{ entry.invoiceNumber }}</a>
                        </td>

                        <td data-label="Proposal Subtotal">
                            {{ entry.proposalSubtotal | currency }}
                        </td>

                        <td data-label="Tax rate">
                            {{ entry.taxRate }}
                        </td>

                        <td data-label="Tax Name">
                            {{ entry.proposalTaxName }}
                        </td>

                        <td data-label="PROPOSAL Sales Tax">
                            {{ entry.proposalSalesTax | currency }}
                        </td>

                        <td data-label="Accepted Proposal">
                            {{ entry.totalSales | currency }}
                        </td>

                        <td data-label="INVOICED Sales Tax">
                            {{ entry.invoicedSalesTax | currency }}
                        </td>

                        <td data-label="Invoice Amount">
                            {{ entry.invoiceAmount | currency }}
                        </td>

                        <td data-label="Amount Paid">
                            {{ entry.amountPaid | currency }}
                        </td>

                        <td data-label="Payment Type">
                            {{ entry.paymentType }}
                        </td>

                        <td data-label="Payment Date">
                            {{ entry.paymentDate | formatDateTime: true }}
                        </td>

                        <td data-label="Balance Due On Project">
                            {{ entry.balanceDueOnProject | currency }}
                        </td>
                    </tr>

                    <tr *ngIf="entries.length === 0">
                        <td colspan="13" class="text-center py-4">No Entries</td>
                    </tr>
                </tbody>

                <tfoot *ngIf="entries.length > 0">
                    <tr>
                        <td><strong>Totals</strong></td>

                        <td></td>

                        <td>
                            <strong>{{ totals.proposalSubtotal | currency }}</strong>
                        </td>

                        <td></td>
                        <td></td>

                        <td>
                            <strong>{{ totals.proposalSalesTax | currency }}</strong>
                        </td>

                        <td>
                            <strong>{{ totals.totalSale | currency }}</strong>
                        </td>

                        <td>
                            <strong>{{ totals.invoicedSalesTax | currency }}</strong>
                        </td>

                        <td>
                            <strong>{{ totals.invoiceAmount | currency }}</strong>
                        </td>

                        <td>
                            <strong>{{ totals.amountPaid | currency }}</strong>
                        </td>

                        <td></td>
                        <td></td>

                        <td>
                            <strong>{{ totals.balanceDueOnProject | currency }}</strong>
                        </td>
                    </tr>
                </tfoot>
            </table>

            <div class="scrollable" *ngIf="isMobile">
                <ul class="list-group">
                    <li *ngFor="let entry of entries" class="list-group-item list-group-item-action">
                        <div class="d-flex list-group-container">
                            <div>
                                <strong>{{ entry.clientName }}</strong>

                                <div>
                                    <strong>Invoice Number: </strong>
                                    <a [routerLink]="`/invoices/${entry.invoiceId}`">{{ entry.invoiceNumber }}</a>
                                </div>

                                <div>
                                    <strong>Proposal Subtotal: </strong>
                                    {{ entry.proposalSubtotal | currency }}
                                </div>

                                <div>
                                    <strong>Tax rate: </strong>
                                    {{ entry.taxRate }}
                                </div>

                                <div>
                                    <strong>Tax Name: </strong>
                                    {{ entry.proposalTaxName }}
                                </div>

                                <div>
                                    <strong>Proposal Sales Tax: </strong>
                                    {{ entry.proposalSalesTax | currency }}
                                </div>

                                <div>
                                    <strong>Accepted Proposal: </strong>
                                    {{ entry.totalSales | currency }}
                                </div>

                                <div>
                                    <strong>Invoiced Sales Tax: </strong>
                                    {{ entry.invoicedSalesTax | currency }}
                                </div>

                                <div>
                                    <strong>Invoice Amount: </strong>
                                    {{ entry.invoiceAmount | currency }}
                                </div>

                                <div>
                                    <strong>Amount Paid: </strong>
                                    {{ entry.amountPaid | currency }}
                                </div>

                                <div>
                                    <strong>Payment Type: </strong>
                                    {{ entry.paymentType }}
                                </div>

                                <div>
                                    <strong>Payment Date: </strong>
                                    {{ entry.paymentDate | formatDateTime: true }}
                                </div>

                                <div>
                                    <strong>Balance Due: </strong>
                                    {{ entry.balanceDueOnProject | currency }}
                                </div>
                            </div>
                        </div>
                    </li>

                    <li *ngIf="entries.length === 0" class="list-group-item">
                        No Entries
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row table-controls">
        <div *ngIf="tableControls.isNotDefault() && !isMobile" class="col-auto mt-3 me-2 me-md-0">
            <button type="button" class="btn btn-outline-danger" (click)="tableControls.resetTableConfiguration()">
                <fa-icon class="button-icon-left" [icon]="faRotateLeft"></fa-icon>
                <span>Reset</span>
            </button>
        </div>

        <div class="col mt-3">
            <div ngbDropdown placement="top-left" class="d-inline-block">
                <button class="btn btn-outline-primary" ngbDropdownToggle>
                    <span *ngIf="!isMobile">Page Size: </span>
                    {{ tableControls.getLimit() }}
                </button>

                <div ngbDropdownMenu class="page-size-dropdown" *ngIf="!isMobile">
                    <button ngbDropdownItem (click)="tableControls.setLimit(20)">
                        20
                    </button>

                    <button ngbDropdownItem (click)="tableControls.setLimit(50)">
                        50
                    </button>

                    <button ngbDropdownItem (click)="tableControls.setLimit(100)">
                        100
                    </button>
                </div>

                <div ngbDropdownMenu class="page-size-dropdown" *ngIf="isMobile">
                    <button ngbDropdownItem (click)="tableControls.setLimit(5)">
                        5
                    </button>

                    <button ngbDropdownItem (click)="tableControls.setLimit(10)">
                        10
                    </button>

                    <button ngbDropdownItem (click)="tableControls.setLimit(20)">
                        20
                    </button>
                </div>
            </div>
        </div>

        <div class="col my-3">
            <ngb-pagination class="d-flex justify-content-end" *ngIf="entryCount > 0"
                [page]="tableControls.getCurrentPage()" [pageSize]="tableControls.getLimit()"
                [collectionSize]="entryCount" [boundaryLinks]="true" [maxSize]="isMobile ? 3 : 10" [ellipses]="true"
                [rotate]="true" (pageChange)="tableControls.setCurrentPage($event)"></ngb-pagination>
        </div>
    </div>
</div>

<ng-template #SORT_DROPDOWN>
    <div ngbDropdown class="d-inline-block" [autoClose]="true" placement="bottom-left">
        <button class="btn btn-outline-primary mt-1" ngbDropdownToggle ngbTooltip="Sort">
            <fa-icon [icon]="faSortAmountDownAlt"></fa-icon>
        </button>

        <div ngbDropdownMenu>
            <button *ngFor="let sort of sortOptions" ngbDropdownItem (click)="sorting(sort.value)">
                {{ sort.label }}

                <fa-icon *ngIf="sortBy === sort.value" [icon]="sortDirection === 'ASC' ? faSortDown : faSortUp"
                    class="sortButton"></fa-icon>
            </button>
        </div>
    </div>
</ng-template>